import { utils } from '@febos-io/common';

export const getConfig = ({
  companyId,
  parameter,
  parameters,
  reference,
  maxLevel = 100
}) => ({
  path: `v1/companies/${companyId}/settings`,
  params: {
    parameter,
    parameters,
    reference,
    maxLevel
  }
});

export const getConfigs = ({
  companyId,
  parameters = [],
  reference,
  maxLevel = 100
}) => ({
  path: `v1/companies/${companyId}/settings`,
  params: {
    parameters,
    reference,
    maxLevel
  }
});

export const saveConfig = (
  companyId,
  {
    value,
    parameter,
    level,
    reference
  }
) => ({
  path: `v1/companies/${companyId}/settings`,
  method: utils.METHOD.POST,
  content: {
    value,
    level,
    parameterId: parameter,
    referenceId: reference
  }
});
